import {
    DELIVERY_POS,
    DELIVERY_INPOST,
    DELIVERY_UPS,
    DELIVERY_DEFAULT,
    DELIVERY_FOREIGN_UPS,
    PAYMENT_PAYU_LOAN,
    PAYMENT_PAYU_PAYPO,
    PAYMENT_PAYU,
    PAYMENT_WIRETRANSFER,
    CASH_ON_DELIVERY_UPS,
    CASH_ON_DELIVERY, CASH_ON_DELIVERY_INPOST, DELIVERY_PACZKOMAT
} from '../config/martix';

export default class DeliveryMatrix {

    constructor() {
        this.basketTotalValue = $('.cart-totals__order > .amount').data('total');

        this.data = {};

        this.data['pl'] = {};
        this.data['notPl'] = {};
        this.data['pl'][DELIVERY_DEFAULT] = [PAYMENT_PAYU,PAYMENT_PAYU_LOAN,PAYMENT_PAYU_PAYPO,CASH_ON_DELIVERY_INPOST,PAYMENT_WIRETRANSFER];
        this.data['pl'][DELIVERY_UPS] = [PAYMENT_PAYU,PAYMENT_PAYU_LOAN,PAYMENT_PAYU_PAYPO,CASH_ON_DELIVERY_UPS,PAYMENT_WIRETRANSFER];
        this.data['pl'][DELIVERY_INPOST] = [PAYMENT_PAYU,PAYMENT_PAYU_LOAN,PAYMENT_PAYU_PAYPO, CASH_ON_DELIVERY_INPOST,PAYMENT_WIRETRANSFER];
        this.data['pl'][DELIVERY_PACZKOMAT] = [PAYMENT_PAYU,PAYMENT_PAYU_LOAN,PAYMENT_PAYU_PAYPO,PAYMENT_WIRETRANSFER,CASH_ON_DELIVERY_INPOST];
        this.data['pl'][DELIVERY_POS] = [PAYMENT_PAYU,PAYMENT_PAYU_LOAN,PAYMENT_PAYU_PAYPO,CASH_ON_DELIVERY,PAYMENT_WIRETRANSFER];

        this.data['notPl'][0] = [PAYMENT_PAYU,PAYMENT_PAYU_LOAN,PAYMENT_PAYU_PAYPO,PAYMENT_WIRETRANSFER];
        this.data['notPl'][DELIVERY_FOREIGN_UPS] = [PAYMENT_PAYU,PAYMENT_PAYU_LOAN,PAYMENT_PAYU_PAYPO,PAYMENT_WIRETRANSFER];

        this.filter = {
            'country' : 'pl',
            'delivery' : DELIVERY_DEFAULT
        };
    }

    getDeliveryMethodsByCountry(country) {
        let data = [];

        if(country === 'PL') {
            data = this.data['pl'];
            this.filter.country = 'pl';
        } else {
            this.filter.country = 'notPl';
            data = this.data['notPl'];
        }

        return Object.keys(data);
    }

    getAvailablePaymentMethods(delivery = null, country = null) {
        if(country == null) {
            country = this.filter.country;
        }

        if(delivery == null) {
            delivery = this.filter.delivery;
        }

        if(delivery === null) {
            return this.data[country][0];
        } else {
            let result = this.data[country][delivery];

            if(this.basketTotalValue > 5000) {
                const index = result.indexOf(CASH_ON_DELIVERY_INPOST);
                if (index > -1) {
                    result.splice(index, 1);
                }
            }

            if(this.basketTotalValue > 15000) {
                const index = result.indexOf(CASH_ON_DELIVERY_UPS);
                if (index > -1) {
                    result.splice(index, 1);
                }
            }

            return result;
        }
    }

    getByCountry(country) {
        if(country === 'PL') {
            return this.data['pl'][0];
        }
        else {
            return this.data['notPl'];
        }
    }

    getPayment(delivery = 0) {
        return this.data[this.country][delivery];
    }

    setCountry(country) {
        this.country = country;
    }

    setDelivery(delivery) {
        this.filter.delivery = delivery;
    }
}
